import { motion, AnimatePresence } from 'framer-motion'
import { useLocation } from 'react-router-dom'

interface RouteTransitionProps {
  children: React.ReactNode
}

export default function RouteTransition({ children }: RouteTransitionProps) {
  const location = useLocation()

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  )
}
